import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import { AppService } from './app.service';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit {

 
  loginFormGroup = new FormGroup({
    username: new FormControl(''),
    password: new FormControl('')
  })


  signupDone = false

  wrongInput = false
  wrongInputReason = ""

  constructor(private serv: AppService, private router: Router) { }

  ngOnInit(): void {
  }


  onSubmit() {
    let fg = this.loginFormGroup

    //Check if fields are filled out
    if (fg.get('username').value == "" || fg.get('password').value == "") {
        this.wrongInput = true
        this.wrongInputReason = "Begge felter skal være udfyldt!"
        return
     }

     this.serv.login(fg.get('username').value, fg.get('password').value).subscribe(ret => {
       if (!ret['result']) {
        this.wrongInput = true
        this.wrongInputReason = ret['reason']
       } else {
         console.log('Logged in')
         if (this.serv.willGoBack) {
          this.router.navigate([this.serv.savedRoute])
         } else {
          this.router.navigate(['/allgear'])
         }
       }
     })

  }
}
